// Device copy of unlocked keys (SECURITY.md §4 "Device copies"). On the web the
// nearest thing to an OS keystore is IndexedDB holding non-extractable
// CryptoKey objects: usable by this origin, never readable as bytes.
const DB = 'klinixis-keys';
const STORE = 'keys';

interface Stored { clinicId: string; version: number; aes: CryptoKey; index: CryptoKey }

function open(): Promise<IDBDatabase> {
  return new Promise((res, rej) => {
    const req = indexedDB.open(DB, 1);
    req.onupgradeneeded = () => req.result.createObjectStore(STORE, { keyPath: ['clinicId', 'version'] });
    req.onsuccess = () => res(req.result);
    req.onerror = () => rej(req.error);
  });
}

function tx<T>(mode: IDBTransactionMode, fn: (s: IDBObjectStore) => IDBRequest<T>): Promise<T> {
  return open().then((db) => new Promise<T>((res, rej) => {
    const r = fn(db.transaction(STORE, mode).objectStore(STORE));
    r.onsuccess = () => res(r.result);
    r.onerror = () => rej(r.error);
  }));
}

export async function storeClinicKeys(clinicId: string, version: number, aes: CryptoKey, index: CryptoKey): Promise<void> {
  await tx('readwrite', (s) => s.put({ clinicId, version, aes, index } satisfies Stored));
}

export async function loadClinicKeys(clinicId: string): Promise<Stored[]> {
  const all = await tx<Stored[]>('readonly', (s) => s.getAll());
  return all.filter((k) => k.clinicId === clinicId);
}

export async function clearClinicKeys(clinicId: string): Promise<void> {
  const all = await loadClinicKeys(clinicId);
  for (const k of all) await tx('readwrite', (s) => s.delete([k.clinicId, k.version]));
}
